export function isUTR(utr) {
    const utrPattern = /^\d{12}$/;
    return utrPattern.test(utr);
}